<template>
    <div class="virtual-pay-modal" v-if="hasVirtualPay">
        <BottomModal ref="virtualPayModal">
            <div v-if="hasDisplayTitle" class="virtual-pay-modal-title flex align-center justify-start margin-bottom-sm text-df">
                <div class="padding-lr-sm">支付技术服务费</div>
                <div class="cuIcon-question text-gray"></div>
            </div>
            <slot></slot>
            <div slot="part">
                <div class="padding-sm">
                    <div class="text-40 text-500">支付技术服务费</div>
                    <div class="margin-top-xxl text-lg text-enter">
                        <p>从2026年4月1日开始收取腾讯技术服务费；</p>
                        <br />
                        <p>苹果用户标准费率20%，腾讯技术服务费2026年限时减免，收取12%（全部为Apple佣金）；</p>
                        <br />
                        <p>安卓、鸿蒙、Windows标准费率10%,腾讯技术服务费2026年限时减免，收取1%。</p>
                        <br>&nbsp;</br>
                    </div>
                </div>
            </div>
        </BottomModal>
    </div>

</template>

<script>
import App from '../util/comfun'
import Env from '../util/env'
import BottomModal from './common/bottom-modal.vue';
export default {
    components: {
        BottomModal
    },
    name: 'VirtualPayModal',
    props: {
        // Define your props here
        hasDisplayTitle: {//是否显示标题
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            // Component state
            hasVirtualPay: false,//是否显示支付技术服务费弹窗
        };
    },
    methods: {
        // Component methods
        show() {
            this.$refs.virtualPayModal.show();
        },
        hide() {        
            this.$refs.virtualPayModal.hide();
        },
        async init(){
            this.hasVirtualPay = Env.isInMiniProgramSync();  
        }
    },
    mounted() {
        // Lifecycle hook
        this.init();

    }
};
</script>

<style scoped>
@import "../../static/icon.css";

.virtual-pay-modal {
    /* Styles for the modal */
    position: relative;
}

.virtual-pay-modal-title {
    /* Styles for the modal */
    width: 355px;
    height: 30px;
    border-radius: 5px;
    opacity: 1;
    box-sizing: border-box;

}
</style>


// WEBPACK FOOTER //
// src/components/virtualPayModal.vue